import { ImageComponent, toPlaceholderImage } from '@frontend/internal-assets';
import type { ImageAssetProps } from '@frontend/internal-assets';
import optimizedImage from './image-assets/online-scheduling.webp';

const thumbHashString = 'r/eFCoI6uKeKc3D2ald/dQdIdIZ2eHg=';
const placeholderImage = toPlaceholderImage(thumbHashString);

const calculatedAspectRatio = 2.216083150984683;
const originalWidth = 4051;

const OnlineScheduling = ({ aspectRatio = calculatedAspectRatio, width = originalWidth, ...rest }: ImageAssetProps) => (
  <ImageComponent
    aspectRatio={aspectRatio}
    width={width}
    src={optimizedImage}
    placeholderSrc={placeholderImage}
    {...rest}
  />
);

export default OnlineScheduling;
